import React, { useState } from 'react';
import Quote from '../quote';
const plans = [
    {
        id: 1,
        name: 'Purchase Pre-existing Solution',
        price: '$21.00',
        subtitle: 'Per Single Assignment',
        description: 'This an already done solution that works as a revision guide',
        buttonText: 'Get a Quote',
        purchaseLink: '#',
        features: [
            'Get your Course Done on your behalf by our Professionals',
            '100% Confidentiality'
        ]
    },
    {
        id: 2,
        name: 'Purchase Single Original Solution',
        price: '$30',
        subtitle: 'Per page per each assignment',
        buttonText: 'Get a Quote',
        purchaseLink: '#',
        features: [
            'Original Turnitin pass',
            'Ready for submission in your class',
            'Human Regenerated content; not AIs',
            'Early Delivery',
            'Early Delivery'
        ]
    },
    {
        id: 3,
        name: 'Purchase Entire Course Solution',
        price: '$99',
        subtitle: 'Per each course',
        description: 'All listed Solution Files are available for Purchase',
        buttonText: 'Get a Quote',
        purchaseLink: '#',
        features: [
            'Already Solution available for Download',
            'Vivid Guidelines for each Assignment file',
            'Instant Delivery',
            'Easy to Download',
            '100% Confidentiality'
        ]
    },
    {
        id: 4,
        name: 'Purchase Entire Course Solution',
        active: true,
        badgeText: 'Popular',
        price: '$100',
        subtitle: 'Per week',
        description: '',
        buttonText: 'Get a Quote',
        purchaseLink: '#',
        features: [
            'Original work guaranteed',
            'You relax and we take all tasks for the class',
            'Submissions are done on your behalf',
            'Plagiarism Free and Turnitin Pass',
            'Human Generated Content',
            'Grade A and Minimum B guaranteed',
            'Money Back Guarantee Blow Grade B',
            'ENL writers to Take your Class',
            '100% Confidentiality'
        ]
    }
]

const Pricing = () => {
    const [isQuote, setIsQuote] = useState(false);

    return (
        <>
            <div className="edu-pricing-area edu-section-gap bg-image">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-12">
                            <div className="section-title text-start">
                                <span className="pre-title">Pricing Plan</span>
                                <h3 className="title">Choose Your Pricing Plan</h3>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {
                            plans.map((data, index) => (
                                <div className="col-lg-6 col-md-6 col-12" key={index} style={{ marginTop: 20 }}>
                                    <div className={`pricing-table`} style={{ display: 'flex', flexDirection: 'column', height: '100%', marginTop: '0px', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <div className="pricing-header">
                                                {
                                                    data.active === true && <div className="edu-badge"><span>{data.badgeText}</span></div>
                                                }
                                                <h3 className="title">{data.name}</h3>
                                                <p>Starting at:</p>
                                                <div className="price-wrap">
                                                    <div className="yearly-pricing">
                                                        <span className="amount">{data.price}</span>
                                                    </div>
                                                </div>
                                                <p>{data.subtitle}</p>
                                                <p>{data.description}</p>
                                            </div>
                                            {data.features && data.features.length > 0 &&
                                                <div className="pricing-body">
                                                    <ul className="list-item">
                                                        {
                                                            data.features.map((feature, i) => <li key={i}><i className="icon-checkbox-circle-line"></i>{feature}</li>)
                                                        }
                                                    </ul>
                                                </div>
                                            }
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                                            <div className="pricing-btn">
                                                <button className={`edu-btn ${data.active !== true ? ' btn-dark' : ''}`} onClick={() => setIsQuote(true)}>
                                                    {data.buttonText}<i className="icon-arrow-right-line-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
            <Quote
                isSearchOpen={isQuote}
                setIsSearchOpen={setIsQuote}
            />
        </>
    )
}

export default Pricing;